export default {
	sendEvent: (category, action, label, value) => {
		try {
			window.dataLayer.push({
				event: 'GAEventPortal', // helper.IsTpn() ? 'GAEventFNB' : 'GAEventPortal',
				eventCategory: category,
				eventAction: action,
				eventLabel: label,
				eventValue: value
			});
		} catch (err) {
			console.error(err);
		}
	},

	sendEventButtonClick: (action, label, value) => {
		try {
			window.dataLayer.push({
				event: 'GAEventPortal', // helper.IsTpn() ? 'GAEventFNB' : 'GAEventPortal',
				eventCategory: 'click',
				eventAction: action,
				eventLabel: label,
				eventValue: value
			});
		} catch (err) {
			console.error(err);
		}
	},

	sendPageView: (title, url) => {
		try {
			window.dataLayer.push({
				event: 'pageview', // helper.IsTpn() ? 'virtualPageviewFNB' : 'virtualPageviewPortal',
				page: {
					path: url,
					title: title
				}
			});
		} catch (err) {
			console.error(err);
		}
	},
	sendVirtualPageViewPortal: (title, url) => {
		try {
			window.dataLayer.push({
				event: 'virtualPageviewPortal', // helper.IsTpn() ? 'virtualPageviewFNB' : 'virtualPageviewPortal',
				virtualPageViewURL: url,
				virtualPageViewTitle: title
			});
		} catch (err) {
			console.error(err);
		}
	}
};
